module.exports = __webpack_public_path__ + "static/icons/icon-mis-seguros-proyeccion-vf1.b77d8fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf1.svg
// module id = p1MI
// module chunks = 1